import { render } from "./GotchiImage.vue?vue&type=template&id=73bde6d2&scoped=true"
import script from "./GotchiImage.vue?vue&type=script&lang=js"
export * from "./GotchiImage.vue?vue&type=script&lang=js"

import "./GotchiImage.vue?vue&type=style&index=0&id=73bde6d2&scoped=true&lang=css"

import exportComponent from "/media/riven/projects/aavegotchi/waardrobe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73bde6d2"]])

export default __exports__